// поиск ссылки, начинающейся с http/https/ftps/www и заканчивающейся либо пробелом, либо '<'
export const linksReg = /(https?:\/\/|ftps?:\/\/|www\.)((?![.,?!;:()]*(\s|<|$))[^\s]){2,}/gim;
